import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import ApolloClient from "apollo-client";
import { createPersistedQueryLink } from "apollo-link-persisted-queries";
import { ApolloLink } from 'apollo-link';

const httpLink = new HttpLink({
  uri: process.env.PREACT_APP_API_ENDPOINT || "https://feed.newsner.com/v1/graphql",
  headers: {
    token: process.env.PREACT_APP_API_TOKEN || "3SMJTijZI5BrFldRospqd7RX8MkUjQ8I"
  }
});

const link = ApolloLink.from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    if (networkError) console.log(`[Network error]: ${networkError}`);
  }),
  createPersistedQueryLink({ useGETForHashedQueries: false }).concat(httpLink)
]);

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link
});
